<template>

  
    <nav class="navbar indigo darken-4">
      <div class="nav-wrapper">        
        <ul class="left">        
          <li>
            <a href="#" @click.prevent="sideBarMenuOpen">          
              <i class="material-icons white-text">{{(value) ? 'menu_open' : 'menu'}}</i>         
            </a>  
          </li>  
        </ul>

        <ul class="center">        
          <li>            
            <h5 class="no-margin">Lehrerin</h5>
          </li>  
        </ul>


        <ul class="right">
          <li>
            <a class="dropdown-trigger white-text" href="#" data-target="dropdown3" ref="dropdown3">
              {{userName}}
              <i class="material-icons right">arrow_drop_down</i>
            </a>

            <ul id="dropdown3" class="dropdown-content">
              <li>
                <router-link to="/profile" class="black-text">
                  <i class="material-icons">account_circle</i>
                  Профиль
                </router-link>
              </li>
              <li class="divider"></li>
              <li>
                <a href="#" class="black-text" @click.prevent="logout">
                  <i class="material-icons">assignment_return</i>
                  Выход
                </a>
              </li>
            </ul>
          </li>
        </ul>

      </div>
    </nav>
  

    

</template>

<style scoped>
.fontbold {
  font-weight: bold;
}
.no-margin {
  margin: 0;
}

</style>


<script>
export default {
  props: ["value"],
  data: () => ({   
    sideBarOpened: true,
    dropdown3: null
  }),
  computed: {
    userName() {
      return this.$store.getters.user.name;
    },
    userEmail() {
      return this.$store.getters.user.email;
    }
  },
  mounted() {   
    this.dropdown3 = M.Dropdown.init(this.$refs.dropdown3, {
      constrainWidth: false
    });
  },
  beforeDestroy() {
    if (this.dropdown3 && this.dropdown3.destroy) {
      this.dropdown3.destroy();
    }
  },
  methods: {
    sideBarMenuOpen(){
      this.sideBarOpened = !this.sideBarOpened;
      this.$emit('clickSideBarMenu');
    },
    async logout() {
      await this.$store.dispatch("logout", {
        email: this.userEmail,
        islogin: false
      });
      this.$router.push("/login");
    }
  }
};
</script>
